export enum FlightEventType {
    Uncategorized = 'Uncategorized',
    System = 'System',
    ServiceExtension = 'ServiceExtension',
    UAV = 'UAV',
    Mission = 'Mission',
    Sensor = 'Sensor',
    FlightSession = 'FlightSession',
}